import { Button, Modal, Form, Col, Row } from 'react-bootstrap'
import StudentCourseService from '../../service/studentCourseService'
import CourseService from '../../service/courseService'
import { successNotify, errorNotify } from '../Utils/Toast'
import { getPosSkillSpc, getSpcAvailable } from '../Utils'
import DatePicker from 'react-multi-date-picker'
import opacity from 'react-element-popper/animations/opacity'
import thai from '../../components/Utils/DatePicker/thai'
import thai_th from '../../components/Utils/DatePicker/thai_th'
import { useParams } from 'react-router-dom'
import React, { useState, useEffect } from 'react'

import './StudentChangeTermModal.css'
const spcs = require('../../utils/SpcGroup')

export default function StudentChangeTermModal({
  courseUpdateAvailable,
  getStudentCourse,
  showStudentChangeTermModal,
  setShowStudentChangeTermModal,
  studentChangeData,
  role,
  terms,
  token,
  sortProfile,
  isStudentCourseApprove,
  courseInfo,
  majorCourse,
}) {
  const isFinalCourse = majorCourse.type === 'final'
  const { course_name } = useParams()
  const [selectedPositionAddDate, setSelectedPositionAddDate] = useState()
  const [positionAdd, setPositionAdd] = useState()
  const [selectedPositionAddDateTemp, setSelectedPositionAddDateTemp] =
    useState()
  const [positionAddTemp, setPositionAddTemp] = useState()
  const [term, setTerm] = useState(studentChangeData?.temp_term)
  const [termTemp, setTermTemp] = useState(studentChangeData?.temp_term)
  const [termReserve, setTermReserve] = useState()
  const [termReserveTemp, setTermReserveTemp] = useState()
  const [eclScore, setEclScore] = useState(studentChangeData?.ecl_score || 0)
  const [health, setHealth] = useState(studentChangeData?.health)
  const [healthTemp, setHealthTemp] = useState(studentChangeData?.health)
  const [note, setNote] = useState()
  const [eclScoreTemp, setEclScoreTemp] = useState(
    studentChangeData?.ecl_score || 0,
  )
  const [eclUnitAvaliable, setEclUnitAvaliable] = useState()
  const [eclUnitAvaliableTemp, setEclUnitAvaliableTemp] = useState()
  const [eclUnitScore, setEclUnitScore] = useState()
  const [eclUnitScoreTemp, setEclUnitScoreTemp] = useState()
  const [eclUnitDate, setEclUnitDate] = useState()
  const [eclUnitDateTemp, setEclUnitDateTemp] = useState()
  const [noteTemp, setNoteTemp] = useState()
  const [changeTermDisable, setChangeTermDisable] = useState()
  const [qualificationStatus, setQualificationStatus] = useState([])
  const [healthCheckLocate, setHealthCheckLocate] = useState()
  const [healthCheckLocateTemp, setHealthCheckLocateTemp] = useState()
  const [spcNo, setSpcNo] = useState()
  const [spcNoTemp, setSpcNoTemp] = useState()
  const [levelUpPlan, setLevelUpPlan] = useState()
  const [levelUpPlanTemp, setLevelUpPlanTemp] = useState()
  const [planDisable, setPlanDisable] = useState()
  const [spcUnitChangeDisabled, setSpcUnitChangeDisable] = useState(true)
  const [spcAvailable, setSpcAvailable] = useState([])

  const birthDate = new Date(studentChangeData.birthDate).toLocaleDateString(
    'th-TH',
    {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  )
  const rankDate = new Date(
    studentChangeData.pme_data.RANK_DATE,
  ).toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
  const startDate = new Date(
    studentChangeData.pme_data.START_DATE,
  ).toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
  const handleClose = () => {
    setShowStudentChangeTermModal(false)
  }

  const checkSpcAvailableEdit = async () => {
    // const isSpcUnitBlank = studentChangeData?.spcNo == 404
    const posSkillSpc = getPosSkillSpc(
      studentChangeData?.pme_data?.POSSKILL
        ? studentChangeData?.pme_data?.POSSKILL[0]
        : studentChangeData?.pme_data?.SKILL_NO_01,
    )
    // console.log('studentChangeData?.pme_data?.SKILL_NO_01', studentChangeData?.pme_data?.SKILL_NO_01)
    const skl01 = (
      studentChangeData?.pme_data?.SKILL_NO_01
        ? studentChangeData?.pme_data?.SKILL_NO_01
        : '00'
    ).substring(0, 2)
    console.log('POSSKILL', studentChangeData?.pme_data.POSSKILL)
    const isEquals = posSkillSpc == skl01
    const Spcs = getSpcAvailable(
      studentChangeData?.pme_data?.POSSKILL || [],
      studentChangeData?.pme_data.SKILL_NO_01,
      studentChangeData?.pme_data.SKILL_NO_02,
      studentChangeData?.pme_data.SKILL_NO_03,
    )
    console.log('Spcs', Spcs)
    setSpcAvailable(Spcs)
    setSpcNo(studentChangeData?.spcNo)
    if (Spcs.length == 1) {
      setSpcNoTemp(Spcs[0].no)
    } else {
      setSpcNoTemp(
        studentChangeData?.spcNo != 404
          ? studentChangeData?.spcNo
          : posSkillSpc,
      )
    }
    // setSpcUnitChangeDisable(isEquals || role == 'adminUnitSpc')
    setSpcUnitChangeDisable(!(Spcs.length > 1))
  }

  useEffect(async () => {
    setEclUnitAvaliable(studentChangeData?.ecl_unit_avaliable)
    setEclUnitAvaliableTemp(studentChangeData?.ecl_unit_avaliable)
    setEclUnitScore(studentChangeData?.ecl_unit_score)
    setEclUnitScoreTemp(studentChangeData?.ecl_unit_score)
    setEclUnitDate(studentChangeData?.ecl_unit_date)
    setEclUnitDateTemp(studentChangeData?.ecl_unit_date)
    switch (role) {
      case 'admin':
        setTerm(studentChangeData?.term)
        setTermTemp(studentChangeData?.term)
        setTermReserve(studentChangeData?.reserve_term)
        setTermReserveTemp(studentChangeData?.reserve_term)
        setChangeTermDisable(false)
        setSelectedPositionAddDate(studentChangeData?.positionAddDate)
        setSelectedPositionAddDateTemp(studentChangeData?.positionAddDate)
        setPositionAdd(studentChangeData?.positionAdd)
        setPositionAddTemp(studentChangeData?.positionAdd)
        setNote(studentChangeData?.note)
        setNoteTemp(studentChangeData?.note)
        setHealthCheckLocate(studentChangeData?.healthCheckLocate)
        setHealthCheckLocateTemp(studentChangeData?.healthCheckLocate)
        break
      case 'adminViewer':
        setTerm(studentChangeData?.term)
        setTermTemp(studentChangeData?.term)
        setTermReserve(studentChangeData?.reserve_term)
        setTermReserveTemp(studentChangeData?.reserve_term)
        setChangeTermDisable(false)
        setSelectedPositionAddDate(studentChangeData?.positionAddDate)
        setSelectedPositionAddDateTemp(studentChangeData?.positionAddDate)
        setPositionAdd(studentChangeData?.positionAdd)
        setPositionAddTemp(studentChangeData?.positionAdd)
        setNote(studentChangeData?.note)
        setNoteTemp(studentChangeData?.note)
        setHealthCheckLocate(studentChangeData?.healthCheckLocate)
        setHealthCheckLocateTemp(studentChangeData?.healthCheckLocate)
        break
      case 'adminUnitSpc':
        setTerm(studentChangeData?.line_term)
        setTermTemp(studentChangeData?.line_term)
        setTermReserve(studentChangeData?.line_reserve_term)
        setTermReserveTemp(studentChangeData?.line_reserve_term)
        setChangeTermDisable(
          isStudentCourseApprove ||
            !courseInfo.isUnitSpcDateAvaliable ||
            studentChangeData?.unit_term == '0',
        )
        setSelectedPositionAddDate(studentChangeData?.positionAddDateUnitSpc)
        setSelectedPositionAddDateTemp(
          studentChangeData?.positionAddDateUnitSpc,
        )
        setPositionAdd(studentChangeData?.positionAddUnitSpc)
        setPositionAddTemp(studentChangeData?.positionAddUnitSpc)
        setNote(studentChangeData?.spc_note)
        setNoteTemp(studentChangeData?.spc_note)
        setHealthCheckLocate(studentChangeData?.healthCheckLocate)
        setHealthCheckLocateTemp(studentChangeData?.healthCheckLocate)
        setLevelUpPlan(studentChangeData?.levelUpPlanUnitSpc)
        setLevelUpPlanTemp(studentChangeData?.levelUpPlanUnitSpc)
        setPlanDisable(studentChangeData?.levelUpPlanUnitSpc === true)
        break
      case 'adminUnit':
        setTerm(studentChangeData?.unit_term)
        setTermTemp(studentChangeData?.unit_term)
        setTermReserve(studentChangeData?.unit_reserve_term)
        setTermReserveTemp(studentChangeData?.unit_reserve_term)
        setChangeTermDisable(
          isStudentCourseApprove || !courseInfo.isUnitDateAvaliable,
        )
        setSelectedPositionAddDate(studentChangeData?.positionAddDateUnit)
        setSelectedPositionAddDateTemp(studentChangeData?.positionAddDateUnit)
        setPositionAdd(studentChangeData?.positionAddUnit)
        setPositionAddTemp(studentChangeData?.positionAddUnit)
        setNote(studentChangeData?.unit_note)
        setNoteTemp(studentChangeData?.unit_note)
        setHealthCheckLocate(studentChangeData?.healthCheckLocate)
        setHealthCheckLocateTemp(studentChangeData?.healthCheckLocate)
        setLevelUpPlan(studentChangeData?.levelUpPlanUnit)
        setLevelUpPlanTemp(studentChangeData?.levelUpPlanUnit)
        setPlanDisable(studentChangeData?.levelUpPlanUnit === true)
        if (
          studentChangeData?.ecl_unit_avaliable == undefined &&
          isFinalCourse
        ) {
          setEclUnitAvaliableTemp(true)
        }
        break
    }
    checkSpcAvailableEdit()
    const courseService = new CourseService()
    const res = await courseService.checkStudentQualification(
      course_name,
      studentChangeData.airforceId,
      token,
    )
    if (res.length > 0) setQualificationStatus(res)
  }, [])

  useEffect(async () => {
    if (levelUpPlanTemp === true) {
      setPositionAddTemp('')
      setSelectedPositionAddDateTemp(undefined)
      setPlanDisable(true)
    }
    if (levelUpPlanTemp === undefined || !levelUpPlanTemp) {
      setPlanDisable(false)
    }
  }, [levelUpPlanTemp])

  const handleUpdateStudentCourseTermOrder = async (changeData) => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.updateStudentCourseTermOrder(
      course_name,
      changeData,
      token,
    )
    if (res.type != 'error') {
      successNotify('แก้ไขข้อมูลสำเร็จ')
      if (sortProfile) {
        getStudentCourse(btoa(JSON.stringify(sortProfile)))
      } else {
        getStudentCourse()
      }
    } else {
      errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด')
    }
  }

  const handleOnStudentCourseSave = async (e) => {
    e.preventDefault()

    console.log('spcNo != spcNoTemp', spcNo != spcNoTemp)
    console.log('spcNo', spcNo)
    console.log('spcNoTemp', spcNoTemp)

    const isHealthCheckLocateEmpty =
      healthCheckLocateTemp == '-' || !healthCheckLocateTemp
    const isPositionAddEmpty = !positionAddTemp || positionAddTemp == ''
    const isSelectedPositionAddDatdEmpty = !selectedPositionAddDateTemp
    const isTermDeafault = term == '1' || term == '0'
    const isAdminUnitAndChangeTerm = role == 'adminUnit' && !isTermDeafault
    const isAdminUnitSpcAndChangeTerm =
      role == 'adminUnitSpc' && !isTermDeafault

    if (
      (isAdminUnitAndChangeTerm || isAdminUnitSpcAndChangeTerm) &&
      !levelUpPlanTemp &&
      (isHealthCheckLocateEmpty ||
        isPositionAddEmpty ||
        isSelectedPositionAddDatdEmpty)
    ) {
      if (isPositionAddEmpty) {
        document.getElementById('textPositionAddAlert').classList.add('show')
        document.getElementById('positionAddField').focus()
      }
      if (isSelectedPositionAddDatdEmpty) {
        document
          .getElementById('textPositionAddDateAlert')
          .classList.add('show')
      }
      if (isHealthCheckLocateEmpty) {
        document.getElementById('healthCheckLocateField').focus()
        document
          .getElementById('textHealthCheckLocateAlert')
          .classList.add('show')
      }
    } else if (
      (isAdminUnitAndChangeTerm || isAdminUnitSpcAndChangeTerm) &&
      isHealthCheckLocateEmpty
    ) {
      if (isHealthCheckLocateEmpty) {
        document.getElementById('healthCheckLocateField').focus()
        document
          .getElementById('textHealthCheckLocateAlert')
          .classList.add('show')
      }
    } else {
      if (
        termTemp !== term ||
        termReserve !== termReserveTemp ||
        eclScore != eclScoreTemp ||
        note != noteTemp ||
        health != healthTemp ||
        selectedPositionAddDate != selectedPositionAddDateTemp ||
        positionAdd != positionAddTemp ||
        healthCheckLocate != healthCheckLocateTemp ||
        levelUpPlan != levelUpPlanTemp ||
        eclUnitAvaliable != eclUnitAvaliableTemp ||
        eclUnitScore != eclUnitScoreTemp ||
        eclUnitDate != eclUnitDateTemp ||
        spcNo != spcNoTemp
      ) {
        switch (role) {
          case 'adminUnit':
            unitChange()
            break
          case 'adminUnitSpc':
            lineChange()
            break
          default:
            adminChange()
            break
        }
      }
      setShowStudentChangeTermModal(false)
    }
  }

  const unitChange = async () => {
    console.log('selectedPositionAddDateTemp', selectedPositionAddDateTemp)
    const changeDataTemp = {
      studentId: studentChangeData._id,
      currentTerm: studentChangeData.unit_term,
      forwardTerm: term,
      termReserve: termReserveTemp,
      positionAdd: positionAddTemp,
      positionAddDate: selectedPositionAddDateTemp,
      note: noteTemp,
      healthCheckLocate: healthCheckLocateTemp,
      levelUpPlan: levelUpPlanTemp,
      spcNo: spcNoTemp,
      eclUnitAvaliable: eclUnitAvaliableTemp,
      eclUnitScore: eclUnitScoreTemp,
      eclUnitDate: eclUnitDateTemp,
    }
    handleUpdateStudentCourseTermOrder(changeDataTemp)
  }

  const lineChange = async () => {
    const changeDataTemp = {
      studentId: studentChangeData._id,
      currentTerm: studentChangeData.line_term,
      forwardTerm: term,
      termReserve: termReserveTemp,
      positionAdd: positionAddTemp,
      positionAddDate: selectedPositionAddDateTemp,
      note: noteTemp,
      levelUpPlan: levelUpPlanTemp,
    }
    handleUpdateStudentCourseTermOrder(changeDataTemp)
  }

  const adminChange = async () => {
    const changeDataTemp = {
      studentId: studentChangeData._id,
      currentTerm: studentChangeData.term,
      forwardTerm: term,
      termReserve: termReserveTemp,
      eclScore: eclScoreTemp,
      note: noteTemp,
      health: healthTemp,
      positionAdd: positionAddTemp,
      positionAddDate: selectedPositionAddDateTemp,
      healthCheckLocate: healthCheckLocateTemp,
      spcNo: spcNoTemp,
      eclUnitAvaliable: eclUnitAvaliableTemp,
      eclUnitScore: eclUnitScoreTemp,
      eclUnitDate: eclUnitDateTemp,
    }
    handleUpdateStudentCourseTermOrder(changeDataTemp)
  }

  const handleDeleteStudentCouse = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.deleteStudentCourseById(
      studentChangeData._id,
      token,
    )
    if (res.type != 'error') {
      successNotify('ลบข้อมูลสำเร็จ')
      if (sortProfile) {
        getStudentCourse(btoa(JSON.stringify(sortProfile)))
      } else {
        getStudentCourse()
      }
    } else {
      errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด')
    }
    setShowStudentChangeTermModal(false)
  }

  return (
    <>
      <Modal
        show={showStudentChangeTermModal}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'>
        <Form onSubmit={handleOnStudentCourseSave}>
          <Modal.Header closeButton>
            <Modal.Title>
              แก้ไข{' '}
              <span className='airforce-id'>
                {studentChangeData?.airforceId}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={4}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ชื่อ:</Form.Label>
                  <Form.Control
                    value={`${studentChangeData?.rankAbbrName}${studentChangeData?.fullName}`}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>วันเดือนปีเกิด:</Form.Label>
                  <Form.Control value={birthDate} disabled />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>อายุ:</Form.Label>
                  <Form.Control value={studentChangeData?.age} disabled />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>เหล่า:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.ARM_ABBR_NAME || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group
                  as={Col}
                  controlId='name'
                  onChange={(e) => setEclScoreTemp(e.target.value)}>
                  <Form.Label>ผลสอบภาษาอังกฤษ:</Form.Label>
                  <Form.Control
                    disabled={role != 'admin'}
                    type='number'
                    min={0}
                    max={100}
                    defaultValue={studentChangeData?.ecl_score || 0}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ตำแหน่ง:</Form.Label>
                  <Form.Control
                    value={
                      studentChangeData?.pme_data?.POS_ORG_ABBR_NAME || '-'
                    }
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>สังกัด:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.ORG_ABBR_NAME}
                    disabled
                  />
                </Form.Group>
              </Col>
              {role == 'admin' && (
                <Col md={2}>
                  <Form.Group as={Col} controlId='name'>
                    <Form.Label>สายวิทยาการ:</Form.Label>
                    <Form.Control
                      as='select'
                      disabled={spcUnitChangeDisabled}
                      value={spcNoTemp}
                      onChange={(e) => {
                        setSpcNoTemp(e.target.value)
                      }}>
                      {spcAvailable.map((spc) => (
                        <option value={spc.no}>{spc.name}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              )}
              {role != 'admin' && (
                <Col md={2}>
                  <Form.Group as={Col} controlId='name'>
                    <Form.Label>สายวิทยาการ:</Form.Label>
                    <Form.Control value={studentChangeData?.spcName} disabled />
                  </Form.Group>
                </Col>
              )}
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>วันยศปัจจุบัน:</Form.Label>
                  <Form.Control value={rankDate} disabled />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>เวลาครองยศ:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.seniorOfRankText}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>วันที่บรรจุ:</Form.Label>
                  <Form.Control value={startDate} disabled />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ประวัติการศึกษารวม:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.EDU || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId='levelUpPlan'>
                  <Form.Label>นขต.ภาษาอังกฤษ: </Form.Label>
                  <Form.Check
                    disabled={role != 'adminUnit' && role != 'admin'}
                    // required={role == 'adminUnit' && isFinalCourse}
                    onChange={(e) => setEclUnitAvaliableTemp(e.target.checked)}
                    checked={eclUnitAvaliableTemp}
                    label='มีคะแนนภาษาอังกฤษ'
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group
                  as={Col}
                  onChange={(e) => setEclUnitScoreTemp(e.target.value)}>
                  <Form.Label>นขต.ภาษาอังกฤษ: </Form.Label>
                  <Form.Control
                    disabled={
                      (role != 'adminUnit' && role != 'admin') ||
                      !eclUnitAvaliableTemp
                    }
                    required={eclUnitAvaliableTemp}
                    type='number'
                    min={10}
                    max={100}
                    defaultValue={studentChangeData?.ecl_unit_score || 0}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId='formBasicSelect'>
                  <Form.Label>นขต.ภาษาอังกฤษ: </Form.Label>
                  <DatePicker
                    required={eclUnitAvaliableTemp}
                    disabled={
                      (role != 'adminUnit' && role != 'admin') ||
                      !eclUnitAvaliableTemp
                    }
                    id='positionAddDateField'
                    inputClass='form-control'
                    locale={thai_th}
                    format='DD/MM/YYYY'
                    animations={[opacity()]}
                    value={eclUnitDateTemp}
                    onChange={(date) =>
                      setEclUnitDateTemp(
                        new Date(date.year, date.month.index, date.day),
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {role != 'adminUnit' && (
                <Col md={6}>
                  <Form.Group as={Col} controlId='name'>
                    <Form.Label>ตำแหน่งที่จะย้ายเข้าหน่วย:</Form.Label>
                    <Form.Control
                      value={studentChangeData?.positionAddUnit || '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
              )}
              {role != 'adminUnit' && role != 'adminUnitSpc' && (
                <Col md={6}>
                  <Form.Group as={Col} controlId='name'>
                    <Form.Label>ตำแหน่งที่จะย้ายเข้าสาย:</Form.Label>
                    <Form.Control
                      value={studentChangeData?.positionAddUnitSpc || '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
              )}
              {role == 'adminUnitSpc' && (
                <Col md={4}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setHealthCheckLocateTemp(e.target.value)}>
                    <Form.Label>สถานที่ตรวจสุขภาพ: </Form.Label>
                    <Form.Control
                      as='select'
                      value={healthCheckLocateTemp}
                      onChange={(e) => {
                        setHealthCheckLocateTemp(e.target.value)
                      }}
                      disabled={changeTermDisable} // TODO CHECK
                      id='healthCheckLocateField'>
                      <option value={'-'}>{'--ยังไม่ได้เลือก--'}</option>
                      <option value={'1'}>{'สวบ.ทอ.'}</option>
                      <option value={'2'}>{'พอ.(กวป.ฯ)'}</option>
                    </Form.Control>
                    <Form.Text
                      className='healt-locate-muted-alert'
                      id='textHealthCheckLocateAlert'>
                      กรุณาเลือก สถานที่ตรวจสุขภาพ.
                    </Form.Text>
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ลชทอ.หลัก:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.SKILL_NO_01 || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ลชทอ.รอง1:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.SKILL_NO_02 || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ลชทอ.รอง2:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.SKILL_NO_03 || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>ลชทอ.หน้าที่:</Form.Label>
                  <Form.Control
                    value={studentChangeData?.pme_data?.POSSKILL || '-'}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>คะแนนประเมิน รอบ เม.ย.</Form.Label>
                  <Form.Control
                    value={
                      studentChangeData?.pme_data?.SCORE_CURRENT_APR || '-'
                    }
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group as={Col} controlId='name'>
                  <Form.Label>คะแนนประเมิน รอบ ต.ค.</Form.Label>
                  <Form.Control
                    value={
                      studentChangeData?.pme_data?.SCORE_CURRENT_OCT || '-'
                    }
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group
                  as={Col}
                  onChange={(e) => setHealthTemp(e.target.value)}>
                  <Form.Label>ผลการตรวจร่างกาย: </Form.Label>
                  <Form.Control
                    as='select'
                    value={healthTemp}
                    disabled={role != 'admin'}>
                    <>
                      <option disabled selected={healthTemp == undefined}>
                        {'ยังไม่ได้ส่งผล'}
                      </option>
                      <option value={true}>{'ผ่าน'}</option>
                      <option value={false}>{'ไม่ผ่าน'}</option>
                    </>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group
                  as={Col}
                  onChange={(e) => setNoteTemp(e.target.value)}>
                  <Form.Label>หมายเหตุ: </Form.Label>
                  <Form.Control as='textarea' rows={2} value={noteTemp} />
                </Form.Group>
              </Col>
            </Row>
            {(role == 'admin' || role == 'adminViewer') && (
              <Row>
                <Col md={4}>
                  <Form.Group as={Col}>
                    <Form.Label>รุ่นสำรอง(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      value={studentChangeData?.unit_reserve_term_text}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group as={Col}>
                    <Form.Label>รุ่นสำรอง(สาย): </Form.Label>
                    <Form.Control
                      disabled
                      value={studentChangeData?.line_reserve_term_text}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setHealthCheckLocateTemp(e.target.value)}>
                    <Form.Label>สถานที่ตรวจสุขภาพ: </Form.Label>
                    <Form.Control
                      as='select'
                      value={healthCheckLocateTemp}
                      onChange={(e) => {
                        setHealthCheckLocateTemp(e.target.value)
                      }}
                      disabled={changeTermDisable} // TODO CHECK
                      id='healthCheckLocateField'>
                      <option value={'-'}>{'--ยังไม่ได้เลือก--'}</option>
                      <option value={'1'}>{'สวบ.ทอ.'}</option>
                      <option value={'2'}>{'พอ.(กวป.ฯ)'}</option>
                    </Form.Control>
                    <Form.Text
                      className='healt-locate-muted-alert'
                      id='textHealthCheckLocateAlert'>
                      กรุณาเลือก สถานที่ตรวจสุขภาพ.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            )}
            {(role == 'admin' || role == 'adminViewer') && (
              <Row>
                <Col md={6}>
                  <Form.Group as={Col}>
                    <Form.Label>หมายเหตุ(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      as='textarea'
                      rows={2}
                      value={studentChangeData?.unit_note}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group as={Col}>
                    <Form.Label>หมายเหตุ(สาย): </Form.Label>
                    <Form.Control
                      disabled
                      as='textarea'
                      rows={2}
                      value={studentChangeData?.spc_note}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            {role == 'adminUnitSpc' && (
              <Row>
                <Col md={6}>
                  <Form.Group as={Col}>
                    <Form.Label>รุ่นสำรอง(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      value={studentChangeData?.unit_reserve_term_text}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group as={Col}>
                    <Form.Label>หมายเหตุ(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      as='textarea'
                      rows={2}
                      value={studentChangeData?.unit_note}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            {(role === 'admin' ||
              role === 'adminViewer' ||
              role === 'adminUnitSpc') && (
              <Row>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>แผนสิทธิ์เข้าอัตรา(หน่วย): </Form.Label>
                    <Form.Check
                      disabled={true}
                      checked={studentChangeData?.levelUpPlanUnit}
                      label='ไม่มีแผน'
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>สิทธิ์เข้าอัตราสูงขึ้น:(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      value={studentChangeData?.positionAddDateUnitTh}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>ตำแหน่งที่จะย้ายเข้า:(หน่วย): </Form.Label>
                    <Form.Control
                      disabled
                      value={studentChangeData?.positionAddUnit}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            {role != 'admin' && role != 'adminViewer' && (
              <Row>
                <Col md={3}>
                  <Form.Group controlId='levelUpPlan'>
                    <Form.Label>แผนสิทธิ์เข้าอัตราสูงขึ้น: </Form.Label>
                    <Form.Check
                      disabled={changeTermDisable}
                      onChange={(e) => setLevelUpPlanTemp(e.target.checked)}
                      checked={levelUpPlanTemp}
                      label='ไม่มีแผน'
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId='formBasicSelect'>
                    <Form.Label>สิทธิ์เข้าอัตราสูงขึ้น: </Form.Label>
                    <DatePicker
                      id='positionAddDateField'
                      inputClass='form-control'
                      // calendar={thai}
                      locale={thai_th}
                      format='DD/MMMM/YYYY'
                      animations={[opacity()]}
                      value={selectedPositionAddDateTemp}
                      disabled={planDisable || changeTermDisable} // TODO CHECK
                      onChange={(date) =>
                        setSelectedPositionAddDateTemp(
                          new Date(date.year, date.month.index, date.day),
                        )
                      }
                    />
                    <Form.Text
                      className='position-add-date-muted-alert'
                      id='textPositionAddDateAlert'>
                      กรุณาเลือก สิทธิ์เข้าอัตราสูงขึ้น.
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setPositionAddTemp(e.target.value)}>
                    <Form.Label>ตำแหน่งที่จะย้ายเข้า: </Form.Label>
                    <Form.Control
                      disabled={planDisable || changeTermDisable}
                      value={positionAddTemp}
                      placeholder='นยส.ผยส.กปซ.ศซบ.ทอ.'
                      id='positionAddField'
                    />
                    <Form.Text
                      className='position-add-muted-alert'
                      id='textPositionAddAlert'>
                      กรุณาเลือก ตำแหน่งที่จะย้ายเข้า.
                    </Form.Text>
                  </Form.Group>
                </Col>
                {role == 'adminUnit' && (
                  <Col md={3}>
                    <Form.Group
                      as={Col}
                      onChange={(e) =>
                        setHealthCheckLocateTemp(e.target.value)
                      }>
                      <Form.Label>สถานที่ตรวจสุขภาพ: </Form.Label>
                      <Form.Control
                        as='select'
                        value={healthCheckLocateTemp}
                        onChange={(e) => {
                          setHealthCheckLocateTemp(e.target.value)
                        }}
                        disabled={changeTermDisable} // TODO CHECK
                        id='healthCheckLocateField'>
                        <option value={'-'}>{'--ยังไม่ได้เลือก--'}</option>
                        <option value={'1'}>{'สวบ.ทอ.'}</option>
                        <option value={'2'}>{'พอ.(กวป.ฯ)'}</option>
                      </Form.Control>
                      <Form.Text
                        className='healt-locate-muted-alert'
                        id='textHealthCheckLocateAlert'>
                        กรุณาเลือก สถานที่ตรวจสุขภาพ.
                      </Form.Text>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            )}
            {majorCourse.type === 'final' && (
              <>
                <Row>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>รุ่น นนอ.</Form.Label>
                      <Form.Control
                        value={
                          studentChangeData?.pme_data?.AIRCADET_CLASS || '-'
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>ปีจบ นนอ.</Form.Label>
                      <Form.Control value='-' disabled />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>คะแนน นนอ.</Form.Label>
                      <Form.Control value='-' disabled />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>รุ่น นม.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.GEN_NO_OTS || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>ปีจบ นม.</Form.Label>
                      <Form.Control
                        value={
                          studentChangeData?.pme_data?.YEAR_SUCCESS_OTS || '-'
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>คะแนน นม.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.OTS || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>รุ่น นฝ.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.GEN_NO_SOS || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>ปีจบ นฝ.</Form.Label>
                      <Form.Control
                        value={
                          studentChangeData?.pme_data?.YEAR_SUCCESS_SOS || '-'
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>คะแนน นฝ.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.SOS || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>รุ่น เสธ,นอส.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.GEN_NO_ACSC || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>ปีจบ เสธ,นอส.</Form.Label>
                      <Form.Control
                        value={
                          studentChangeData?.pme_data?.YEAR_SUCCESS_ACSC || '-'
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group as={Col} controlId='name'>
                      <Form.Label>คะแนน เสธ,นอส.</Form.Label>
                      <Form.Control
                        value={studentChangeData?.pme_data?.ACSC || '-'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              {/* <a onClick={handleOnCheckQualification}>ตรวจสอบคุณสมบัติ</a> */}
              <p>
                ตรวจสอบคุณสมบัติ:{' '}
                {qualificationStatus.length == 0 && (
                  <span className='pass-qualification'>ผ่านคุณสมบัติ</span>
                )}
              </p>
              {qualificationStatus.map((data, index) => (
                <span className='not-pass-qualification'>
                  {index + 1}. {data}
                </span>
              ))}
            </Row>
            <Row>
              <Form.Group controlId='formBasicSelect'>
                <Form.Label>รุ่น: </Form.Label>
                <Form.Control
                  as='select'
                  value={term}
                  onChange={(e) => {
                    setTerm(e.target.value)
                  }}
                  disabled={changeTermDisable} // TODO CHECK
                >
                  {terms.map((data, index) => (
                    <>
                      {index == 0 && (
                        <option value={data.id}>
                          {'ยังไม่ได้เลือกรุ่นการศึกษา'}
                        </option>
                      )}
                      {index > 0 && index + 1 !== terms.length && (
                        <option
                          disabled={!data.enabled}
                          value={data.id}>{`รุ่นที่ ${data.name}`}</option>
                      )}
                      {index + 1 === terms.length &&
                        (role === 'admin' || role === 'adminViewer') && (
                          <option value={data.id}>{'สำรอง'}</option>
                        )}
                    </>
                  ))}
                </Form.Control>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group controlId='formTermReserveTempSelect'>
                <Form.Label>รุ่นสำรอง: </Form.Label>
                <Form.Control
                  as='select'
                  value={termReserveTemp}
                  onChange={(e) => {
                    setTermReserveTemp(e.target.value)
                  }}
                  disabled={changeTermDisable} // TODO CHECK
                >
                  {terms.map((data, index) => (
                    <>
                      {index == 0 && (
                        <option value={data.id}>
                          {'ยังไม่ได้เลือกรุ่นสำรองการศึกษา'}
                        </option>
                      )}
                      {index > 0 && index + 1 !== terms.length && (
                        <option
                          disabled={!data.enabled}
                          value={data.id}>{`รุ่นที่ ${data.name}`}</option>
                      )}
                      {index + 1 === terms.length &&
                        (role === 'admin' || role === 'adminViewer') && (
                          <option value={data.id}>{'สำรอง'}</option>
                        )}
                    </>
                  ))}
                </Form.Control>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            {role === 'admin' && (
              <Button
                variant='danger'
                onClick={handleDeleteStudentCouse}
                disabled={!courseUpdateAvailable}>
                ลบ
              </Button>
            )}
            <Button variant='secondary' onClick={handleClose}>
              ปิด
            </Button>
            {courseUpdateAvailable && (
              <Button
                variant='primary'
                type='submit'
                disabled={!courseUpdateAvailable}>
                บันทึก
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}
